import APP_ROUTES, { LANDING_LIBRARY_PREFIX } from '@src/app_routes';

export const isLibraryEditPage = (pathname) => {
  return pathname.includes('/' + LANDING_LIBRARY_PREFIX + '/');
};

export const getLibraryIdFromUrl = (pathname) => {
  const isPublic = isLibraryEditPage(pathname);
  const pathSplit = pathname.split(
    `${isPublic ? `/${LANDING_LIBRARY_PREFIX}` : APP_ROUTES.videoLibraries}/`
  );
  return pathSplit.length > 1 ? pathSplit.pop().split('/')[0] : null;
};

export const buildLibraryUrl = (pagelink, isPreview = false) => {
  const pathname = '/' + LANDING_LIBRARY_PREFIX + '/' + pagelink;

  if (!isPreview) return pathname;

  return pathname + '?isPreview=true';
};



// WEBPACK FOOTER //
// ./src/helpers/videoCompilationHelper.js